export const pageSize = 20;
export const pageCount = 1;
export const pageNumber = 1;
export const pageSize25 = 25;
export const pageSize50 = 50;
export const pageSize100 = 100;
